export default __webpack_public_path__ + "static/media/coaching.39687b2c.jpg";